import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

import * as FaqApi from './interfaces';
import { handleErrorAndThrow } from '@hiptraveler/data-access/api';
import { brandCampaignId } from '@hiptraveler/common';

@Injectable({
  providedIn: 'root'
})
export class FaqApiService {

  constructor(
    private http: HttpClient
  ) { }

  /**
   * Submits a support ticket
   * @param payload - The support ticket request payload
   * @returns Observable of the API result
   */
  submitSupportTicket(payload: Omit<FaqApi.SupportTicketRequest, 'cId'>): Observable<FaqApi.SupportTicketApiResult> {
    const requestPayload: FaqApi.SupportTicketRequest = {
      ...payload,
      cId: brandCampaignId()
    };

    return this.http.post<FaqApi.SupportTicketApiResult>('/trip-planner/connect/support', requestPayload).pipe(
      tap(handleErrorAndThrow)
    );
  }
}
